import { useEffect, useRef } from 'react';

export default function useInterval(callback: () => void, delay: number, enabled: boolean = true) {
  const savedCallback = useRef(callback);
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  function clear() {
    if (timeout.current) clearInterval(timeout.current);
  }

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    clear();
    if (enabled) {
      timeout.current = setInterval(() => {
        savedCallback.current();
      }, delay);
    }
    return () => clear();
  }, [delay, enabled]);
}
